import withIcon from './NewIcon';
// @ts-ignore
import IconInstagram from './icon/l/instagram.s.svg';

export default withIcon(IconInstagram);
